<template>
  <div class="content-panle margin-0">
    <h3 class="panle-head" style="margin-bottom:16px"> 修改登录密码 </h3>

    <a-form
      v-if="changePasswordType === 0"
      :form="form"
      @submit.prevent="handleChangePassword"
      style="max-width: 800px"
    >
      <!-- 旧密码 -->
      <a-form-item label="旧密码">
        <a-input-password
          type="password" autocomplete="false" placeholder="请输入旧密码"
          v-decorator="[
            'oldPassword',
            { rules: [{ required: true, message: '请输入旧密码！'}] }
          ]"
        >
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input-password>
      </a-form-item>

      <!-- 密码 -->
      <a-popover
        placement="rightTop"
        :trigger="['focus']"
        :getPopupContainer="trigger => trigger.parentElement"
        v-model="showPasswordTip"
      >
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['user-change-password', passwordLevelClass]">
              密码强度：
              <span>{{ passwordLevelName }}</span>
            </div>
            <a-progress
              :percent="passwordStrength"
              :showInfo="false"
              :strokeColor="passwordLevelColor"
            />
            <div style="margin-top: 10px;">
              <span>请输入 8-20 位密码。请不要使用容易被猜到的密码。</span>
            </div>
          </div>
        </template>

        <a-form-item label="新密码">
          <a-input-password
            type="password" autocomplete="false" placeholder="请输入新密码"
            v-decorator="[
              'password',
              { rules: [
                  { required: true, message: '请输入新密码！' },
                  { validator: this.handlePasswordLevel }
                ],
                validateTrigger: ['change', 'blur']
              }
            ]"
            @focus="() => { showPasswordTip = true }"
            @blur="() => { showPasswordTip = false }"
          >
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input-password>
        </a-form-item>
      </a-popover>

      <!-- 确认密码 -->
      <a-form-item label="确认密码">
        <a-input-password
          type="password" autocomplete="false" placeholder="请再次输入密码"
          v-decorator="[
            'repassword',
            { rules: [
                { required: true, message: '请再次输入密码！'},
                { validator: handlePasswordCheck }
              ],
              validateTrigger: ['blur']
            }
          ]"
        >
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input-password>
      </a-form-item>

      <a-form-item>
        <a-button
          type="primary" html-type="submit"
          :disabled="btnSubmit" :loading="btnSubmit"
        >修改密码</a-button>
      </a-form-item>
    </a-form>

    <div v-if="changePasswordType === 1">
      <a-result
        status="success"
        title="修改密码成功！"
        subTitle=""
      >
        <template v-slot:extra>
          <p style="font-size:16px"> {{ reLoginTime }}s 后将重新登录 </p>
          <a-button type="primary" @click="handleBackToSignIn">重新登录</a-button>
        </template>
      </a-result>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { Logout, ChangePassword } from '@/apis/session'

const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}
export default {
  name: 'UserCenterChangePassword',
  components: {},
  data() {
    return {
      form: this.$form.createForm(this),

      changePasswordType: 0, // 修改密码状态 0：还没修改密码；1：修改密码成功

      btnSubmit: false, // 是否正在提交修改密码

      showPasswordTip: false, // 密码强度提示框
      passwordLevel: 0, // 设置密码的等级
      passwordStrength: 10, // 密码强度在强度条中的百分比

      gettingVerifyCode: false, // 是否已经点击‘获取验证码’
      timeCountDown: 60, // 获取手机验证码倒计时

      reLoginTime: 5
    }
  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.passwordLevel]
    },
    passwordLevelName() {
      switch (this.passwordLevel) {
        case 2: return '中'
        case 3: return '强'
        default: return '低'
      }
    },
    passwordLevelColor() {
      return levelColor[this.passwordLevel]
    }
  },
  created() { },

  methods: {
    ...mapMutations([
      'emptyUser',
      'emptyEnums',
      'emptyAliveComponents'
    ]),

    handleChangePassword() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.btnSubmit = true
            await ChangePassword({
              oldPassword: values.oldPassword,
              password: values.password
            })
            this.changePasswordType = 1
            // 开启返回登录倒计时
            this.interval = setInterval(() => {
              if (--this.reLoginTime <= 0) {
                this.handleBackToSignIn()
                clearInterval(this.interval)
                this.interval = null
              }
            }, 1000)
          } catch (error) { }
          this.btnSubmit = false
        }
      })
   
    },

    // 判断输入密码是否为空、是否强度不够
    handlePasswordLevel(rule, value, callback) {
      let level = 0

      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      
      this.passwordLevel = level
      this.passwordStrength = level * 30

      if (level === 0) this.passwordStrength = 10
      if (level >= 3) this.passwordStrength = 100
      
      if (!value) {
        callback()
        return
      }

      if (value.length < 8 || value.length > 20) {
        callback(new Error('请输入 8-20 位密码，区分大小写！'))
        return
      }
      
      if (level >= 2) {
        callback()
      } else {
        callback(new Error('密码强度不够！'))
      }
    },
    // 判断密码输入是否一致
    handlePasswordCheck(rule, value, callback) {
      if (!value) {
        callback()
        return
      } 
      
      const password = this.form.getFieldValue('password')
      if (password && value.trim() !== password.trim()) {
        callback(new Error('两次密码输入不一致！'))
      } else {
        callback()
      }
    },

    // 修改密码成功后返回登录，需要先退出登录
    async handleBackToSignIn() {
      try {
        await Logout()

        this.emptyUser()
        this.emptyEnums()
        this.emptyAliveComponents()
        
        this.$router.push({ path: '/login' })
      } catch (error) {}
    }
  }
}
</script>

<style lang="less">
.user-change-password {
  &.error {
    color: #ff0000;
  }

  &.warning {
    color: #ff7e05;
  }

  &.success {
    color: #52c41a;
  }
}

.user-layout-change-password {
  .ant-input-group-addon:first-child {
    background-color: #fff;
  }
}
</style>
<style lang="less" scoped>
.main {
  width: 420px !important;
  margin-top: 32px;
}
</style>
